(function () {
  var key = 'b4s_customer_height_cm';

  function validHeight(value) {
    var height = Number.parseInt(value, 10);
    return Number.isInteger(height) && height >= 100 && height <= 220 ? height : null;
  }

  function read() {
    try {
      return validHeight(window.localStorage.getItem(key));
    } catch (error) {
      return null;
    }
  }

  function save(value) {
    var height = validHeight(value);
    if (!height) return null;
    try {
      window.localStorage.setItem(key, String(height));
      window.dispatchEvent(new CustomEvent('b4s:height-changed', { detail: { height: height } }));
      return height;
    } catch (error) {
      return null;
    }
  }

  function clear() {
    try {
      window.localStorage.removeItem(key);
      window.dispatchEvent(new CustomEvent('b4s:height-changed', { detail: { height: null } }));
    } catch (error) {
      return;
    }
  }

  window.Bike4SportSizeProfile = { read: read, save: save, clear: clear };
})();

